import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import * as actions from './Login.ducks';
import url from 'url';

import { auth } from 'helpers';
import windowLocation from 'helpers/windowLocation';
import LoginForm from './components/LoginForm';
import ForgotCredentialsModal from 'containers/ForgotCredentialsModal';
import OktaWidgetWraper from './components/OktaWidgetWraper';
import { ThemeContext } from 'zignal-landscape/lib/ThemeProvider';

const mapStateToProps = (
  (state) => ({
    isLoggedIn: state.Login.isLoggedIn,
    fetching: state.Login.fetching,
    errorMessage: state.Login.errorMessage,
    notificationMessage: state.Login.notificationMessage,
    isModalOpen: state.Login.isModalOpen,
    legacyLoginFormWithOkta: state.Login.legacyLoginFormWithOkta
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

export class Login extends Component {

  componentDidMount(){
    const {
      handleLoginRender,
      isOktaLogin
    } = this.props;

    const { query } = url.parse(window.location.href, true);
    if (query.ref) {
      sessionStorage.setItem('loginRedirectRef', query.ref);
    }

    const isSUNetWithOktaLogin = typeof DanaUrl === 'function' && isOktaLogin;
    const isCommandCenter = document.body.className.indexOf('isCommandCenter') > -1;

    handleLoginRender(isSUNetWithOktaLogin || isCommandCenter);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.isLoggedIn && nextProps.isLoggedIn) { // only on false→true transition
      const { query } = url.parse(window.location.href, true);
      let previousLocation = query.ref || sessionStorage.getItem('loginRedirectRef');
      sessionStorage.removeItem('loginRedirectRef');
      let rootUrl = '/';

      if(typeof DanaUrl === 'function') {
        previousLocation = DanaUrl(previousLocation); // eslint-disable-line new-cap
        rootUrl = DanaUrl('/home/'); // eslint-disable-line new-cap
      }
      auth.login();
      windowLocation.assign(previousLocation || rootUrl);
    }
  }

  render() {
    const {
      handleSubmit,
      handleLogin,
      handleOktaLogin,
      handleLoginInputChange,
      handleLoginForgotCredentials,
      handleModalClose,
      errorMessage,
      notificationMessage,
      isModalOpen,
      oktaConfig,
      isOktaLogin,
      OktaSignIn,
      legacyLoginFormWithOkta
    } = this.props;
    const isNewOktaLogin = legacyLoginFormWithOkta === false && isOktaLogin;

    return (
      <ThemeContext.Consumer>
        {(theme) => {
          const logoSrc = isNewOktaLogin ? theme.WhiteLabel.appLogoSrc : theme.WhiteLabel.loginLogoSrc;
          return (
            <div>
              {isNewOktaLogin ?
                <OktaWidgetWraper
                  config={oktaConfig}
                  logoSrc={logoSrc}
                  widgetSuccessCallback={handleOktaLogin}
                  widgetErrorCallback={()=> console.log('error')}
                  OktaSignIn={OktaSignIn}
                  errorMessage={errorMessage}
                />
                :
                <React.Fragment>
                  <LoginForm
                    handleSubmit={handleSubmit(handleLogin)}
                    handleForgotCredentials={handleLoginForgotCredentials}
                    handleInputChange={handleLoginInputChange}
                    errorMessage={errorMessage}
                    notificationMessage={notificationMessage}
                    logoSrc={logoSrc}
                    legacyLoginFormWithOkta={legacyLoginFormWithOkta}
                  />
                  { legacyLoginFormWithOkta === false &&
                  <ForgotCredentialsModal isOpen={isModalOpen} onClose={handleModalClose} />
                  }
                </React.Fragment>
              }
            </div>
          );
        }}
      </ThemeContext.Consumer>
    );
  }
}


Login.contextTypes = {
  theme: PropTypes.object
};

Login.propTypes = {
  handleSubmit: PropTypes.func,
  handleLoginRender: PropTypes.func,
  handleLogin: PropTypes.func,
  handleOktaLogin: PropTypes.func,
  handleLoginInputChange: PropTypes.func,
  handleLoginForgotCredentials: PropTypes.func,
  handleModalClose: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  isModalOpen: PropTypes.bool,
  isOktaLogin: PropTypes.bool,
  legacyLoginFormWithOkta: PropTypes.bool,
  errorMessage: PropTypes.string,
  notificationMessage: PropTypes.string,
  oktaConfig: PropTypes.object,
  OktaSignIn: PropTypes.any
};

Login.defaultProps = {

};

export default connect(mapStateToProps, actions, mergeProps)(
  reduxForm({
    form: 'Login'
  })(Login));
